<template>
	<div class="footer">{{company||'北京来看科技有限公司'}} 版权所有<br/>Copyright © 2011-{{year}} Laikan.com All Rights Reserved.
	</div>
</template>

<script>
	export default {
		computed: {
			company() {
				let company = null
				if (this.$store.state.app.site === 'zuitang') {
					return company = '北京华文印象科技有限公司'
				}
				console.log(this.$store.state.app)
				if (this.$store.state.app.site === 'yynovel') {
					return company = '北京秀闻科技有限公司'
				}
			},
			year() {
				let year = new Date().getFullYear()
				return year
			}
		}
	}
</script>

<style scoped>

	.footer {
		text-align: center;
		color: #666;
		font-size: 12px;
		line-height: 20px;
		padding: 15px 0;
		width: 100%;
		/*background-color: #fff;*/
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/footer.vue